import {
    Grid, makeStyles,
} from '@material-ui/core';
import { useState, Suspense } from 'react';

import { TitledAppBar } from 'src/components/common/TitledAppBar';
import { SearchResultsContainer } from 'src/components/common/Search/SearchResultsContainer';
import { FacetedSearch } from 'src/components/common/Search/FacetedSearch';
import { TaxonomyResults } from 'src/components/Taxonomies/TaxonomyResults';
import { ResultsSkeleton } from 'src/components/common/skeletons/ResultsSkeleton';
import { TAXONOMY_NAME_FACET, FACETS } from 'src/components/Taxonomies/constants';
import { ErrorBoundary } from 'src/components/common/ErrorBoundary';

const useStyles = makeStyles({
    container: {
        gridArea: 'content',
    },
});

export const TaxonomiesPage = (): JSX.Element => {
    const classes = useStyles();
    const [search, setSearch] = useState<App.Taxonomies.PagedSearch>({} as App.Taxonomies.PagedSearch);

    const handleSubmit = (facetedSearch: FacetedSearch.FacetedSearchResult): void => {
        const newSearch = {
            ids: facetedSearch.id as string[],
            names: facetedSearch.names as string[],
            taxonomyIntents: facetedSearch.taxonomyIntents as string[],
        };

        setSearch(newSearch);
    };

    return (
        <>
            <TitledAppBar title="Taxonomies">
                <Grid
                    container
                    justifyContent="center"
                    spacing={2}
                    wrap="nowrap"
                >
                    <Grid item xs={10}>
                        <FacetedSearch
                            defaultFacet={TAXONOMY_NAME_FACET}
                            facets={FACETS}
                            label="Search Taxonomies"
                            onSubmit={handleSubmit}
                        />
                    </Grid>
                </Grid>
            </TitledAppBar>
            <SearchResultsContainer className={classes.container}>
                <ErrorBoundary>
                    <Suspense fallback={<ResultsSkeleton />}>
                        <TaxonomyResults search={search} />
                    </Suspense>
                </ErrorBoundary>
            </SearchResultsContainer>
        </>
    );
};
